import { hot } from 'react-hot-loader/root';
import * as React from 'react';
import Toast from '../web/hooks/public/toast';
import '@webstyles/index.scss';
import { Basics } from '@pubts/context.ts';
import { fetch, StageInfoRsp } from '@pubts/fetch.ts';
// import Apply from '@hooks/apply/index.tsx';
// import { ApplyDefault } from '@/applyContext.ts';
import Tab1 from '../web/hooks/act/tab1/index';
// import Tab2 from '../web/hooks/act/tab2/index';
// import Tab3 from '../web/hooks/act/tab3/index';
import Tab4 from '../web/hooks/act/tab4/index';

/* 引入头图一级 */
const Images = ['header', 'footer', '1-1', '1', '2-1', '2', '3-1', '3', '4-1', '4'].map((item: any) => require(`./images/${item}.png`));
const images = [];
for (let i = 0; i < Images.length; i++) {
  images[i] = new Image();
  images[i].src = Images[i].default;
}
const { useState, useEffect } = React;
interface StyleType {
  width: string,
  height: string,
}
interface TabType {
  tabName: string,
  tabCurrent: number,
  openImg: any,
  closeImg: any,

}
/* 配置tab */
const tabs: TabType[] = [
  {
    tabName: 'tab1',
    tabCurrent: 1,
    openImg: Images[2].default,
    closeImg: Images[3].default,
  },
  {
    tabName: 'tab2',
    tabCurrent: 2,
    openImg: Images[4].default,
    closeImg: Images[5].default,
  },
  {
    tabName: 'tab3',
    tabCurrent: 3,
    openImg: Images[6].default,
    closeImg: Images[7].default,
  },
  {
    tabName: 'tab4',
    tabCurrent: 0,
    openImg: Images[8].default,
    closeImg: Images[9].default,
  },
];
const App: React.FC = () => {
  /* 防抖 */
  const debounce = (wait: number) => {
    let timer: any = null;
    return function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        HeadStyle(styleCompute(960));
        FootStyle(styleCompute(164));
      }, wait);
    }
  }
  const styleCompute: (size: number) => StyleType = size => {
    let styleOutput: StyleType;
    styleOutput = {
      width: `${document.body.offsetWidth > 1300 ? document.body.offsetWidth : 1300}px`,
      height: `${((document.body.offsetWidth > 1300 ? document.body.offsetWidth : 1300) * size) / 1920}px`,
    }
    return styleOutput;
  }
  const [headStyle, HeadStyle] = useState<StyleType>(styleCompute(960));
  const [footStyle, FootStyle] = useState<StyleType>(styleCompute(164));
  const [configuration, setConfiguration] = useState<any>(null)

  useEffect(() => {
    window.onresize = debounce(500);
  }, [])

  /* tab状态 */
  const [tabList] = useState<TabType[]>(tabs);
  const [tabCurrent, TabCurrent] = useState<number>(0);
  const [iStage, Istage] = useState<number>(0)
  useEffect(() => {
    // console.log = () => null;

    $.ajax({
      url: 'https://diy-front.cdn.huya.com/zt/frontpage/c6/202107carracing.html',
      data: {},
      type: 'Get',
      dataType: 'jsonp',
      jsonpCallback: 'callback',
      success(res: any) {
        console.log('配置信息', res);
        setConfiguration(res)

        /* 获取赛程阶段 */
        fetch.getStage202108(
          {
            lPid: 0,
          },
        )
          .then((rsp: StageInfoRsp) => {
            console.log('赛程阶段', rsp);
            if (res.isLock) {
              TabCurrent(0)
              return;
            }
            Istage(rsp.iStage)
            TabCurrent(rsp.iStage >= 4 ? 0 : rsp.iStage)
          })
      },
    })

  }, [])


  /* toast开关 */
  const [showTabToast, ShowTabToast] = useState<string>('');
  const tabToastOpen: (text: string) => void = text => {
    ShowTabToast(text);
    setTimeout(() => {
      ShowTabToast('');
    }, 3000)
  }

  const [applyOpen, ApplyOpen] = useState<boolean>(false);
  const close: () => void = () => {
    ApplyOpen(false);
  }

  return (
    <div id="App">
      {showTabToast !== '' && <Toast text={showTabToast} />}
      <section className='app_bg'>
        { /* 页面头图或者动态头图 */}
        <img
          className='head_cover'
          src={Images[0].default}
          alt='头图'
          style={headStyle}
          id='top'
        />
        {/* <video
          className={'head_cover'}
          src={'https://diy-assets.msstatic.com/hyys/activity/20210421ttsp.mp4'}
          autoPlay={true}
          muted={true}
          loop={true}
          style={headStyle}
          poster={Images[0].default}
          id='top'
        /> */}
        {/* <ApplyDefault.Provider
          value={{close}}
        >
          <Apply show={applyOpen} />
        </ApplyDefault.Provider> */}
        <div className='app_content'>
          {/* <div
            className='apply_btn'
            onClick={
              () => {
                ApplyOpen(true);
              }
            }
          ></div> */}
          { /* 页面tab切换逻辑 */}
          <ul className='tabs'>
            {
              tabList.map((item: TabType) => (
                <li
                  key={item.tabName}
                  style={{
                    backgroundImage: `url(${tabCurrent === item.tabCurrent ? item.openImg : item.closeImg})`,
                    cursor: `${tabCurrent === item.tabCurrent ? 'default' : 'pointer'}`,
                  }}
                  onClick={
                    (): void => {
                      if (item.tabCurrent > iStage) {
                        tabToastOpen('活动暂未开始，敬请期待');
                        return;
                      }
                      TabCurrent(item.tabCurrent);
                    }
                  }
                ></li>
              ))
            }
          </ul>
          <Basics.Provider
            value={
              {
                test: 0,
                iStage,
                tabToastOpen,
                current: tabCurrent,
              }
            }
          >
            {
              /*
                这里根据iStage展示不同组件
              */
              [Tab4, Tab1, Tab1, Tab1].map((item: any, index: number): any => {
                if (index === tabCurrent) {
                  const COMP = item;
                  return <COMP key={index} index={tabCurrent} />
                }
              })
            }
          </Basics.Provider>
        </div>
        { /* 页面底部背景 */}
        <img
          className='foot_cover'
          alt='底部背景'
          src={Images[1].default}
          style={footStyle}
        />
      </section>
    </div>
  )
}

// 开启 webpack 的 HMR
export default hot(App);
